export const QUOTATION_DEFAULTS = Object.freeze({
  branch: "jakarta",
  search: "",
  quotation_type: "",
  quotation_number: "",
  customer_name: "",
  reference: "",
  service_cost_min: "",
  service_cost_max: "",
  created_by: "",
  date_from: "",
  date_to: "",
  date_exact: "",
  sort_by: "",
  sort_order: "desc",
  page: 1,
  page_size: 10,
});

export const QUOTATION_TYPE_BADGE_CLASSES = Object.freeze({
  sq: "border-info/30 bg-info/10 text-info",
  mq: "border-[var(--neon-purple-base)]/30 bg-[var(--neon-purple-base)]/10 text-[var(--neon-purple-base)]",
  cq: "border-success/30 bg-success/10 text-success",
});

const SORT_FIELDS = new Set([
  "date",
  "quotation_number",
  "customer",
  "grand_total",
  "created_by",
]);

export function readQuotationHistoryState(searchParams) {
  const page = Number.parseInt(searchParams.get("page") || "", 10);
  const pageSize = Number.parseInt(searchParams.get("page_size") || "", 10);
  const sortBy = searchParams.get("sort_by") || "";
  const sortOrder = searchParams.get("sort_order");
  return {
    branch: ["jakarta", "surabaya", "bali"].includes(searchParams.get("branch"))
      ? searchParams.get("branch")
      : "jakarta",
    search: (searchParams.get("search") || "").slice(0, 200),
    quotation_type: ["sq", "mq", "cq"].includes(searchParams.get("quotation_type"))
      ? searchParams.get("quotation_type")
      : "",
    quotation_number: (searchParams.get("quotation_number") || "").slice(0, 200),
    customer_name: (searchParams.get("customer_name") || "").slice(0, 200),
    reference: (searchParams.get("reference") || "").slice(0, 200),
    service_cost_min: searchParams.get("service_cost_min") || "",
    service_cost_max: searchParams.get("service_cost_max") || "",
    created_by: searchParams.get("created_by") || "",
    date_from: searchParams.get("date_from") || "",
    date_to: searchParams.get("date_to") || "",
    date_exact: searchParams.get("date_exact") || "",
    sort_by: SORT_FIELDS.has(sortBy) ? sortBy : "",
    sort_order: sortOrder === "asc" ? "asc" : "desc",
    page: Number.isInteger(page) && page >= 1 ? page : 1,
    page_size:
      Number.isInteger(pageSize) && pageSize >= 1 && pageSize <= 100
        ? pageSize
        : 10,
  };
}

export function writeQuotationHistoryState(state) {
  const params = new URLSearchParams();
  if (state.branch && state.branch !== "jakarta") params.set("branch", state.branch);
  [
    "search",
    "quotation_type",
    "quotation_number",
    "customer_name",
    "reference",
    "service_cost_min",
    "service_cost_max",
    "created_by",
    "date_from",
    "date_to",
    "date_exact",
    "sort_by",
  ].forEach((key) => {
    const value = String(state[key] || "").trim();
    if (value) params.set(key, value);
  });
  if (state.sort_by || state.sort_order === "asc") {
    params.set("sort_order", state.sort_order === "asc" ? "asc" : "desc");
  }
  if (state.page > 1) params.set("page", String(state.page));
  if (state.page_size !== 10) params.set("page_size", String(state.page_size));
  return params;
}

export function nextQuotationSort(state, field) {
  return {
    ...state,
    sort_by: field,
    sort_order:
      state.sort_by === field && state.sort_order === "asc" ? "desc" : "asc",
    page: 1,
  };
}

export function quotationReferencePreview(references = []) {
  const visible = references.slice(0, 2);
  return {
    visible,
    hiddenCount: Math.max(0, references.length - visible.length),
  };
}

export function formatQuotationReference(reference, mode) {
  if (["SQ", "MQ", "sq", "mq"].includes(mode)) {
    return [reference?.service_ticket_number, reference?.serial_number]
      .filter(Boolean)
      .join(" · ");
  }
  return reference?.serial_number || "";
}

export function formatQuotationMoney(value) {
  const text = String(value ?? "");
  const match = text.match(/^(-?)(\d+)(?:\.(\d+))?$/);
  if (!match) return text;
  const grouped = match[2].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `Rp ${match[1]}${grouped}${match[3] ? `,${match[3]}` : ""}`;
}
